import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { TranslationService } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { FormV2TypeEnum } from '../shared/enum/form-v2-type.enum';

@Component({
  selector: 'wl-new-form',
  templateUrl: './new-form.component.html',
  styleUrls: ['./new-form.component.less'],
    standalone: false
})
export class NewFormComponent implements OnInit, OnDestroy {
  formTypeOptions: SelectItem[];
  formType = 0;
  formTypeEnum = FormV2TypeEnum;

  constructor(
    private _translationService: TranslationService,
    private _route: ActivatedRoute,
    private _navigationService: NavigationService
  ) {}

  private _onDestroy$ = new Subject<void>();

  async ngOnInit() {
    let joinLabel = await this._translationService.getTitlecase('form-builder.form-type-options.join');
    let donationLabel = await this._translationService.getTitlecase('form-builder.form-type-options.donation');
    let renewalLabel = await this._translationService.getTitlecase('form-builder.form-type-options.renewal');
    let generalLabel = await this._translationService.getTitlecase('form-builder.form-type-options.general');
    let prospectLabel = await this._translationService.getTitlecase('form-builder.form-type-options.prospect');
    this.formTypeOptions = [
      { value: FormV2TypeEnum.Join, label: joinLabel } as SelectItem,
      { value: FormV2TypeEnum.Donation, label: donationLabel } as SelectItem,
      { value: FormV2TypeEnum.Renewal, label: renewalLabel } as SelectItem,
      { value: FormV2TypeEnum.GeneralSurvey, label: generalLabel } as SelectItem,
      { value: FormV2TypeEnum.Prospect, label: prospectLabel } as SelectItem,
    ];

    this._route.queryParams
      ?.pipe(
        map((params) => {
          if (params.type) {
            this.formType = +params.type;
          }
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._onDestroy$.next(null);
  }

  formSaved(formId: number) {
    this._navigationService.navigateToFormEdit(formId, this.formType);
  }
}
